import { AuthType, UserRoles } from "../api";
import { tvpoint } from "../tv";
import { SettingsScope } from "./config";
import { GeneralConfig } from "./general-config";
import { LanguageType, PageIn } from "./misc";
import {  UserPlan, UserSubscription } from "./plans";
import { TickerAssetType, TickerInfo, TimeFrame } from "./tickers";


export interface USUserInfo {
	uid: number;
	login: string;
	expAt: number;
	auth: AuthType;
	pwd: boolean;
	lang: LanguageType;
	plan: UserPlan;
	alertsBot: boolean;
	tls: UserRoles;
	isPaused: boolean;
	subs: UserSubscription[];
}
export interface UserSubInfo {
	ui: USUserInfo;
	plans: UserPlan[];
}

export interface signUpOptions {
	login: string;
	refid: string;
	adid: string;
	notes: string;
	code: string;
	lang: LanguageType;
	planId?: number;
}

export interface SearchTickersIn extends PageIn {
	asset: TickerAssetType;
}
export interface GetMyTickersOut {
	tickers: TickerInfo[];
	used: string[];
}



export enum WithinPeriod {
	Last1d,
	Last4h,
	Last1h
}
export enum StatValueSize {
	NK,
	NM,
	NB
}
export enum WithinBars {
	N50,
	N100,
	N150,
	NMAX
}
export enum ConditionClause {
	Or,
	And
}

export interface TickersStat {
	on: boolean;
	type: TickersStatType;
	
	//item props
	sort?: boolean;
	last?: WithinPeriod;
	tf?: string;
	valueFrom?: number;
	value?: number;
	size?: WithinBars | StatValueSize;
	//group props
	items?: TickersStat[];
	clause?: ConditionClause;
}
export enum TickersStatType {
	Group,
	Volume,
	Eq,
	Cas,
}

export interface BuiltAlertMsg {
	uid: number;
	message: string;
	tf: number;
	f: tvpoint;
	t: tvpoint;
	desc?: string;
	nested: BuiltAlertMsg[];
}
export interface BuiltAlertBias {
	isBull: boolean;
	nested: BuiltAlertMsg[];
}
export interface BuiltAlertTicker {
	monitored: boolean;
	at: number;
	expired?: number;
	ticker: TickerInfo;
	msgs: BuiltAlertBias[];
}

export enum UserTickerType {
	Default = 0,
	Alert = 1,
	Favorite = 2,
	Fav0 = 4 | Favorite,
	Fav1 = 8 | Favorite,
	Fav2 = 16 | Favorite,
	Fav3 = 32 | Favorite,
	Fav4 = 64 | Favorite
}
export interface UserTicker {
	type: UserTickerType;
	id: string;
}
export interface UserSettings {
	tickers: UserTicker[];
	tfs: TimeFrame[];
	tvInit: TradingView.DatafeedConfiguration;
	config: SettingsScope;
	layouts: LayoutData[];
	version: string;
	debug: boolean;
	ui: USUserInfo;
	signal: string;
	trading: string;
}


export interface LayoutData {
	n: string;
	c: any;
}
